import { z } from 'zod';

export const domainZodRuleWithTld = z
  .string()
  .min(1, 'Domain too short! Must be at least 1 characters.')
  .max(63, 'Domain too long!')
  .transform((domain) => domain.toLowerCase())
  .transform((domain) => domain.trim());

export const domainZodRule = z
  .string()
  .min(3, 'Domain too short! Must be at least 3 characters.')
  .max(63, 'Domain too long!')
  .refine((domain) => {
    // should be a valid domain name which can only contain letters (upper or lower), numbers, and hyphens. It accepts tlds as well
    return /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*$/.test(domain);
  }, 'Invalid domain name, can only contain letters, numbers, and hyphens.')
  .transform((domain) => domain.toLowerCase())
  .transform((domain) => domain.trim())
  // remove the tld with the dot if it has one
  .transform((domain) => {
    if (domain.includes('.')) {
      return domain.split('.')[0];
    }
    return domain;
  });
